import { render, staticRenderFns } from "./NotAuthentication.vue?vue&type=template&id=0231355f&scoped=true"
import script from "./NotAuthentication.vue?vue&type=script&lang=js"
export * from "./NotAuthentication.vue?vue&type=script&lang=js"
import style0 from "./NotAuthentication.vue?vue&type=style&index=0&id=0231355f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231355f",
  null
  
)

export default component.exports